import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import eventEmitter from "./eventEmitter";

export function SessionListener() {
    const navigate = useNavigate();

    useEffect(() => {
        const logoutHandler = () => {
            sessionStorage.clear()
            navigate("/login", { replace: true });
        };

        eventEmitter.on("forceLogout", logoutHandler);
        return () => eventEmitter.off("forceLogout", logoutHandler);
    }, [navigate]);

    return null;
}